import {Component} from '@angular/core';
import {UrlService} from '../../../services/url.service';
import {SettingsIncidentReportService} from '../../../services/settings-incident-report.service';

declare const $: any;

@Component({
    selector: 'settings-incident-report-list',
    templateUrl: './settings-incident-report-list.component.html',
    styleUrls: ['./settings-incident-report-list.component.scss']
})
export class SettingsIncidentReportListComponent {

    constructor(public settingsIncidentReportService: SettingsIncidentReportService,
                public urlService: UrlService) {}

    orderBy(orderBy: string, $event) {
        if (this.settingsIncidentReportService.data.allIncidentReportsSettings.total < 2) return;
        this.urlService.orderBy(orderBy, $event);
    }

    showHint(e) {
        e.stopPropagation();
        const $td = $(e.target).closest('.table-hint-td');
        if ($td.hasClass('active'))
            $td.removeClass('active');
        else {
            $('.table-hint-td').removeClass('active');
            $td.addClass('active');
        }
    }

    toggleCheck(selectedItem): void {
        const checked = selectedItem.showDetailedView;
        this.settingsIncidentReportService.data.allIncidentReportsSettings.data.forEach(item => item.showDetailedView = false);
        if (checked && this.settingsIncidentReportService.selectedItemData) {
            this.settingsIncidentReportService.selectedItemData = null;
            this.settingsIncidentReportService.toggleDetailedView(null, false);
            selectedItem.showDetailedView = false;
        } else {
            this.settingsIncidentReportService.selectedItemData = selectedItem;
            selectedItem.showDetailedView = true;
            this.settingsIncidentReportService.toggleDetailedView(selectedItem, true);
        }
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/settings-incident-report/settings-incident-report-list/settings-incident-report-list.component.ts